import { render, staticRenderFns } from "./base-empty.vue?vue&type=template&id=496a331e&"
import script from "./base-empty.vue?vue&type=script&lang=js&"
export * from "./base-empty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports